export default __webpack_public_path__ + "static/media/registrar-atencion.42ab8e13.svg";